import React from "react";

// Model Layout Component - ClimateChange
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const climateLayers = [
  {
    id: "cc0",
    src: "/assets/svgs/climate-change-svgs/cc0.svg",
    alt: "Climate change layered stack",
    style: { left: "40%", top: "58.5%" },
  },
  {
    id: "cc1",
    src: "/assets/svgs/climate-change-svgs/cc1.svg",
    alt: "Trends in humanitarian spending",
    style: { left: "17%", top: "19%" },
  },
  {
    id: "cc2",
    src: "/assets/svgs/climate-change-svgs/cc2.svg",
    alt: "People affected by disasters",
    style: { left: "9%", top: "56%" },
  },
  {
    id: "cc3",
    src: "/assets/svgs/climate-change-svgs/cc3.svg",
    alt: "Climate-related mental disorders",
    style: { left: "27%", top: "36%", zIndex: 90 },
  },
  {
    id: "cc4",
    src: "/assets/svgs/climate-change-svgs/cc4.svg",
    alt: "G20 recommendations and resilience",
    style: { left: "49%", top: "16%", zIndex: 90 },
  },
  {
    id: "cc5",
    src: "/assets/svgs/climate-change-svgs/cc5.svg",
    alt: "Health-related issues and preparedness",
    style: { left: "55%", top: "39.5%", zIndex: 80 },
    tooltip: "Climate change x Gender",
    tooltipPlacement: "left-top",
  },
  {
    id: "cc6",
    src: "/assets/svgs/climate-change-svgs/cc6.svg",
    alt: "Heat-related illnesses and mitigation",
    style: { left: "57%", top: "59.9%", zIndex: 90 },
    tooltip: "Climate change x Gender",
    tooltipPlacement: "left",
  },
  {
    id: "cc7",
    src: "/assets/svgs/climate-change-svgs/cc7.svg",
    alt: "Displacement and migration impacts",
    style: { left: "55.2%", top: "84.9%" },
    tooltip: "Climate change x Gender",
    tooltipPlacement: "left-center",
  },
  {
    id: "cc8",
    src: "/assets/svgs/climate-change-svgs/cc8.svg",
    alt: "Gendered impacts of climate change",
    style: { left: "45%", top: "96%" },
    tooltip: "Climate change x Gender",
  },
  {
    id: "cc9",
    src: "/assets/svgs/climate-change-svgs/cc9.svg",
    alt: "Agriculture and livelihoods",
    style: { left: "35%", top: "49%", zIndex: 100 },
    tooltip: "Climate change x Gender",
    tooltipPlacement: "right",
  },
];

const ClimateChangeModel = ({ className = "", showTooltips = true }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      cc1: "care-sector",
      cc2: "care-sector",
      cc3: "environmental-relations",
      cc4: "care-crisis",
      cc5: "india",
      cc6: "bangladesh",
      cc7: "indonesia",
      cc8: "nepal",
      cc9: "care-sector",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-8">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[1070/865] max-w-[1100px] ${className}`}
        >
          {climateLayers.map((layer) => {
            const interactive = layer.id !== "cc0";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-[4%] -translate-y-1/2 ml-2";
                case "left-center":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "left-top":
                  return "left-[73%] top-[-6%] -translate-y-1/2 ml-2";
                case "right":
                  return "right-[96%] top-[89%] -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-full left-1/2 -translate-x-1/2 -mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${
                  interactive ? "group" : ""
                }`}
                style={layer.style}
              >
                <div className="relative">
                  <img
                    src={layer.src}
                    alt={layer.alt}
                    loading="lazy"
                    className={`select-none object-contain max-w-max ${
                      interactive
                        ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                        : "pointer-events-none"
                    }`}
                    style={interactive ? { ...hoverTiming } : undefined}
                    {...(interactive ? bounceHandlers : {})}
                    {...(handleClick ? { onClick: handleClick } : {})}
                  />
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default ClimateChangeModel;
